module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction to the English-Language Edition: Volodya")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("ONE")]), _c('br'), _vm._v("Life: "), _c('em', [_vm._v("Speak, Memory")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("TWO")]), _c('br'), _vm._v("Reality: "), _c('em', [_vm._v("The Gift, Look at the Harlequins!, The Real Life")]), _vm._v(" of Sebastian Knight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("THREE")]), _c('br'), _vm._v("The Oppressor and the Oppressed: "), _c('em', [_vm._v("Invitation to a Beheading, Bend Sinister")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("FOUR")]), _c('br'), _vm._v("Cruelty: "), _c('em', [_vm._v("Pnin")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("FIVE")]), _c('br'), _vm._v("Genius and Madness: "), _c('em', [_vm._v("Pale Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("SIX")]), _c('br'), _vm._v("Love: "), _c('em', [_vm._v("Lolita")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("SEVEN")]), _c('br'), _vm._v("Heaven and Hell: "), _c('em', [_vm._v("Ada or Ardor")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")]), _vm._v(" Translated by Dorna Khazeni")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibl",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cred",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0